<template>
  <div class="roductPricing">
    <div class="tableContainer">
      <div class="headerLayout">
        <div class="item_">
          <div class="itemTitle">作品信息</div>
          <div class="itemContent">
            <img :src="pageData.result.poster" />
            {{ pageData.result.name }}
          </div>
        </div>
        <div class="item_">
          <div class="itemTitle">字数</div>
          <div class="itemContent">{{  pageData.result.wordsize || '-' }}</div>
        </div>
        <div class="item_">
          <div class="itemTitle">创建时间</div>
          <div class="itemContent">{{ pageData.result.createTime }}</div>
        </div>
        <div class="item_">
          <div class="itemTitle">文章发布时间</div>
          <div class="itemContent">{{ pageData.result.lyUplinkPushTime || pageData.result.uplinkPushTimeTime }}</div>
        </div>
        <!-- <div class="item_">
          <div class="itemTitle">文章发布时间</div>
          <div class="itemContent">100篇</div>
        </div> -->
        <!-- <div class="item_">
          <div class="itemTitle"></div>
          <div class="itemContent_">
            <div>查看</div>
            <div>分享</div>
          </div>
        </div> -->
        <div class="item_">
          <div class="itemTitle">操作</div>
          <div class="itemContent_">
            <div @click="toView(pageData.result)">查看</div>
            <div @click="copyUrl(pageData.result)">分享</div>
          </div>
        </div>
      </div>
    </div>

    <div class="setContainer" v-if="pageData.typeShow">
      <div class="titleView">作品版权授权定价</div>
      <div class="inputSetView">
        <div class="item_">
          <div class="item_title">授权时间</div>
          <div class="item_input">
            <el-input placeholder="" v-model="pageData.interfaceParameters.effectiveTime" />
          </div>
          年
        </div>
        <div class="item_">
          <div class="item_title">独家期</div>
          <div class="item_input">
            <el-input placeholder="" type="number" :min="1" v-model.number="pageData.interfaceParameters.soleEffectiveTime" />
          </div>
          月
        </div>
        <div class="item_">
          <div class="item_title">授权费</div>
          <div class="item_input">
            <el-input placeholder="" v-model="pageData.interfaceParameters.price"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" />
          </div>
          元
        </div>
      </div>
      <div class="titleView">默认授权</div>
      <div class="defaultAuthorization">
        <div v-for="item in pageData.defaultAuthorizationDisplay" :key="item">
          {{ item }}
        </div>
      </div>
      <div class="titleView">更多授权</div>
      <div class="defaultAuthorizationList">
        <div v-for="(item, index) in pageData.defaultAuthorizationList" :key="index" @click="rightListMtn(index)"
          :class="
            pageData.defaultAuthorizationList[index].isTrue ? 'active' : ''
          ">
          {{ item.name }}
        </div>
        <div style="width: 114px; height: 0"></div>
        <div style="width: 114px; height: 0"></div>
        <div style="width: 114px; height: 0"></div>
        <div style="width: 114px; height: 0"></div>
        <div style="width: 114px; height: 0"></div>
      </div>
      <div class="buttonView">
        <div @click="nextJump(1)">跳过</div>
        <div @click="nextJump(2)">下一步</div>
      </div>
    </div>

    <div class="nextSetContainer" v-else>
      <div class="titleView">作品版权授权定价</div>
      <div class="inputSetView marginBottom">
        <div class="item_">
          <div class="item_title">授权时间</div>
          <div class="item_input">
            <el-input placeholder="请输入" type="number" v-model="pageData.interfaceParametersSectionTwo.effectiveTime" />
          </div>
          年
        </div>
        <div class="item_">
          <div class="item_title">独家期</div>
          <div class="item_input">
            <el-input placeholder="请输入" type="number"  min="1" 
              v-model.number="pageData.interfaceParametersSectionTwo.soleEffectiveTime" />
          </div>
          月
        </div>
      </div>

      <div class="titleView">版权价格</div>
      <div class="priceCopyrightView">
        <div class="item_" v-for="item in pageData.issueAuthorizationPrice" :key="item">
          <div class="title_">
            {{ item.name }}

            <el-tooltip class="box-item" effect="dark" content="Bottom Left prompts info" placement="bottom-start"><img
                src="@/assets/images/helpIcon.jpg" alt="" /></el-tooltip>
          </div>
          <div class="input_">
            <el-input type="number" v-model="item.price" /><span>元</span>
          </div>
        </div>
      </div>
      <div class="buttonView">
        <div @click="goback()">上一步</div>
        <div @click="addWorksPriceListFun()">下一步</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { reactive } from "vue";
import { useRoute, useRouter } from "vue-router";

import {
  priceGetWorksComboPriceList,
  addWorksComboPriceList,
  priceGetWorksPriceList,
  addWorksPriceList,
} from "../api/interfaceList";
export default {
  name: "roductPricing",
  components: {},
  setup() {
    const route = useRoute();
    const router = useRouter();

    let pageData = reactive({
      result: JSON.parse(route.query.queryData),
      params: "",
      typeShow: true,
      interfaceParameters: {
        effectiveTime: "",
        soleEffectiveTime: "",
        price: "",
        defaultRightsCategoryArray: [],
        rightsCategoryArray: [],
      },
      interfaceParametersSectionTwo: {
        effectiveTime: "",
        price: "",
        soleEffectiveTime: "",
        worksCode: "",
      },
      defaultAuthorizationDisplay: [],
      defaultAuthorizationList: [],
      issueAuthorizationPrice: [],
    });
    function rightListMtn(index) {
      pageData.defaultAuthorizationList[index].isTrue =
        !pageData.defaultAuthorizationList[index].isTrue;
      let arr = [];
      pageData.defaultAuthorizationList.map((item) => {
        if (item.isTrue) {
          arr.push(item.type);
        }
      });
      pageData.interfaceParameters.rightsCategoryArray = arr;
    }

    function nextJump(type) {
      pageData.issueAuthorizationPrice = [];
      if (type == 1) {
        pageData.typeShow = false;
        priceGetWorksPriceListFun();
      } else {
        let data = {
          uniqueCode: pageData.params.uniqueCode,
          worksCode: pageData.params.worksCode,
        };
        let params = Object.assign(pageData.interfaceParameters, data);
       
        addWorksComboPriceList(params).then((res) => {
          if (res.code == 1) {
            pageData.typeShow = false;
            priceGetWorksPriceListFun();
          } else if (res.code == -1001) {
            ElMessage({
              message: res.data[0].message,
              type: "success",
            });
          } else {
            ElMessage({
              message: "请检查输入参数的格式",
              type: "success",
            });
          }
        });
      }
    }

    function priceGetWorksPriceListFun() {
      priceGetWorksPriceList({
        workCode: pageData.result.uniqueCode,
      }).then((res) => {
        let { data } = res;
        pageData.interfaceParametersSectionTwo.effectiveTime =
          data.effectiveTime ? data.effectiveTime : 3;
        pageData.interfaceParametersSectionTwo.price = data.price ? data.price : 500;
        pageData.interfaceParametersSectionTwo.soleEffectiveTime =
          data.soleEffectiveTime ? data.soleEffectiveTime : 0;
        pageData.interfaceParametersSectionTwo.worksCode = data.worksCode;
        let list = [
          {
            name: "发表权",
            rightsCategoryVail: 0,
            price: "300",
          },
          {
            name: "署名权",
            rightsCategoryVail: 1,
            price: "300",
          },
          {
            name: "修改权",
            rightsCategoryVail: 2,
            price: "300",
          },
          {
            name: "保护作品完整权",
            rightsCategoryVail: 3,
            price: "300",
          },
          {
            name: "复制权",
            rightsCategoryVail: 4,
            price: "300",
          },
          {
            name: "发行权",
            rightsCategoryVail: 5,
            price: "300",
          },
          {
            name: "出租权",
            rightsCategoryVail: 6,
            price: "300",
          },
          {
            name: "展览权",
            rightsCategoryVail: 7,
            price: "300",
          },
          {
            name: "表演权",
            rightsCategoryVail: 8,
            price: "300",
          },
          {
            name: "放映权",
            rightsCategoryVail: 9,
            price: "300",
          },
          {
            name: "广播权",
            rightsCategoryVail: 10,
            price: "300",
          },
          {
            name: "信息网络传播权",
            rightsCategoryVail: 11,
            price: "500",
          },
          {
            name: "摄制权",
            rightsCategoryVail: 12,
            price: "300",
          },
          {
            name: "改编权",
            rightsCategoryVail: 13,
            price: "300",
          },
          {
            name: "翻译权",
            rightsCategoryVail: 14,
            price: "300",
          },
          {
            name: "汇编权",
            rightsCategoryVail: 15,
            price: "300",
          },
          {
            name: "其他",
            rightsCategoryVail: 16,
            price: "300",
          },
        ];
        list.map((item) => {
          data.worksPriceDtos.map((items) => {
            if (item.rightsCategoryVail == items.rightsCategory) {
              if (items.price != null) {
                item.price = items.price;
              }
              pageData.issueAuthorizationPrice.push(item);
            }
          });
        });
      });
    }

    priceGetWorksComboPriceList({
      workCode: pageData.result.uniqueCode,
    }).then((res) => {
      let { data } = res;
      pageData.params = data;
      pageData.interfaceParameters.effectiveTime = data.effectiveTime ? data.effectiveTime : 3;
      pageData.interfaceParameters.soleEffectiveTime = data.soleEffectiveTime
      pageData.interfaceParameters.price = data.price ? data.price : 500;
      data.defaultRightsCategoryList.map((item) => {
        pageData.interfaceParameters.defaultRightsCategoryArray.push(
          item.rightsCategoryType
        );
      });
      let list = [
        {
          name: "发表权",
          type: 0,
          isTrue: false,
        },
        {
          name: "署名权",
          type: 1,
          isTrue: false,
        },
        {
          name: "修改权",
          type: 2,
          isTrue: false,
        },
        {
          name: "保护作品完整权",
          type: 3,
          isTrue: false,
        },
        {
          name: "复制权",
          type: 4,
          isTrue: false,
        },
        {
          name: "发行权",
          type: 5,
          isTrue: false,
        },
        {
          name: "出租权",
          type: 6,
          isTrue: false,
        },
        {
          name: "展览权",
          type: 7,
          isTrue: false,
        },
        {
          name: "表演权",
          type: 8,
          isTrue: false,
        },
        {
          name: "放映权",
          type: 9,
          isTrue: false,
        },
        {
          name: "广播权",
          type: 10,
          isTrue: false,
        },
        {
          name: "信息网络传播权",
          type: 11,
          isTrue: false,
        },
        {
          name: "摄制权",
          type: 12,
          isTrue: false,
        },
        {
          name: "改编权",
          type: 13,
          isTrue: false,
        },
        {
          name: "翻译权",
          type: 14,
          isTrue: false,
        },
        {
          name: "汇编权",
          type: 15,
          isTrue: false,
        },
        {
          name: "其他",
          type: 16,
          isTrue: false,
        },
      ];
      list.map((item) => {
        data.defaultRightsCategoryList.map(items => {
          if (item.type == items.rightsCategoryType) {
            pageData.defaultAuthorizationDisplay.push(item.name);
          }
        })

        data.rightsCategoryList.map((items) => {
          if (items.rightsCategoryType == item.type) {
            item.isTrue = items.choiceStatus;
            pageData.defaultAuthorizationList.push(item);
            if (items.choiceStatus) {
              pageData.interfaceParameters.rightsCategoryArray.push(
                items.rightsCategoryType
              );
            }
          }
        });
      });
    });
    function addWorksPriceListFun() {
      let list = deepCopy(pageData.issueAuthorizationPrice);
      let newList = [];
      list.map((item) => {
        delete item.name;
        item["effectiveTime"] =
          pageData.interfaceParametersSectionTwo.effectiveTime;
        item["soleEffectiveTime"] =
          pageData.interfaceParametersSectionTwo.soleEffectiveTime;
        item["worksCode"] = pageData.params.worksCode;
      });
      list.map((item) => {
        if (item.price) {
          newList.push(item);
        }
      });
      addWorksPriceList(newList).then((res) => {
        if (res.code == 1) {
          router.push({
            path: "pricingSuccessful",
            query: {
              worksCode: pageData.params.worksCode,
            },
          });
        } else if (res.code == -1001) {
          ElMessage({
            message: res.data[0].message,
            type: "success",
          });
        } else {
          ElMessage({
            message: "请检查输入的参数",
            type: "success",
          });
        }
      });
    }
    function deepCopy(obj) {
      let a = JSON.stringify(obj);
      let newobj = JSON.parse(a);
      return newobj;
    }
    function goback() {
      pageData.typeShow = true;
    }
    function toView(e) {
      router.push({
        name: "articleDetails",
        query: { uniqueCode: e.contentUplinkCode },
      });
    }
    function copyUrl(value) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      let url = `http://market.qikan.cn/#/articleDetails?worksCode=${value.uniqueCode}`;
      input.setAttribute("value", url);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(input);
      ElMessage({
        message: "复制成功",
        type: "success",
      });
    }
    return {
      pageData,
      rightListMtn,
      nextJump,
      priceGetWorksPriceListFun,
      addWorksPriceListFun,
      deepCopy,
      goback,
      toView,
      copyUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
.roductPricing {
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  margin-left: 24px;
  padding: 24px 30px;
  box-sizing: border-box;

  .buttonView {
    display: flex;
    align-items: center;
    margin-top: 40px;

    div {
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      line-height: 40px;
      border-radius: 8px;
      text-align: center;
      font-weight: 700;
      cursor: pointer;
    }

    div:nth-of-type(1) {
      width: 120px;
      color: #909399;
      background: #ffffff;
      border: 1px solid #c0c4cc;
      margin-right: 72px;
    }

    div:nth-of-type(2) {
      width: 240px;
      color: #fff;
      background: #008aea;
    }
  }

  .nextSetContainer {
    margin-top: 40px;

    // .buttonView {
    //   width: 240px;
    //   height: 40px;
    //   font-size: 14px;
    //   font-family: AlibabaPuHuiTiM;
    //   color: #ffffff;
    //   line-height: 40px;
    //   text-align: center;
    //   background: #008aea;
    //   border-radius: 8px;
    //   cursor: pointer;
    //   margin-top: 24px;
    // }
    // .buttonView:hover {
    //   background: #6dbbfc;
    // }
    .priceCopyrightView {
      display: flex;
      flex-wrap: wrap;

      .item_ {
        margin: 0 16px 16px 0;

        .input_ {
          display: flex;
          align-items: center;

          span {
            width: 64px;
            height: 24px;
            font-size: 12px;
            font-family: AlibabaPuHuiTiR;
            color: #909399;
            line-height: 24px;
            margin-left: 10px;
          }
        }

        .title_ {
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
          line-height: 24px;
          display: flex;
          align-items: center;

          img {
            width: 14px;
            margin-left: 2px;
            cursor: pointer;
          }
        }
      }
    }

    .titleView {
      margin-bottom: 16px;
      font-size: 16px;
      font-family: AlibabaPuHuiTiM;
      color: #008aea;
      line-height: 24px;
      font-weight: 700;
    }
  }

  .setContainer {
    width: 782px;
    padding: 24px;
    box-sizing: border-box;
    margin-top: 40px;
    background: rgba(255, 178, 0, 0.05);
    border-radius: 10px;
    border: 2px solid #ffb200;

    .titleView {
      margin-bottom: 16px;
      font-size: 16px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
      line-height: 24px;
      font-weight: 700;
    }

    .titleView:first-child {
      color: #008aea;
    }

    .defaultAuthorizationList {
      width: 734px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      div {
        width: 114px;
        height: 40px;
        background: #f5f7fa;
        border-radius: 8px;
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #008aea;
        line-height: 40px;
        text-align: center;
        margin-bottom: 10px;
        cursor: pointer;
        transition: 0.6s all;
      }

      div:hover {
        color: #fff;
        background: #008aea !important;
      }

      .active {
        color: #ffffff !important;
        background: #008aea !important;
      }
    }
  }

  .marginBottom {
    margin-bottom: 40px;
  }

  .inputSetView {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
    font-family: AlibabaPuHuiTiR;
    color: #909399;

    .item_ {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 16px;

      .item_input {
        margin: 0 10px;
      }

      .item_title {
        width: 64px;
        height: 24px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        line-height: 24px;
      }
    }
  }

  .defaultAuthorization {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    div {
      background: #f5f7fa;
      border-radius: 12px;
      height: 24px;
      line-height: 24px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      padding: 0 12px;
      box-sizing: border-box;
      margin: 0 16px 16px 0;
    }
  }

  .tableContainer {
    width: 100%;
    border-bottom: 1px #f5f7fa solid;

    .headerLayout {
      width: 100%;
      display: flex;

      // justify-content: center;
      .item_:nth-of-type(1) {
        width: 300px;
      }

      .item_:nth-of-type(2) {
        width: 108px;
      }

      .item_:nth-of-type(3) {
        width: 236px;
      }

      .item_:nth-of-type(4) {
        width: 236px;
      }

      .item_:nth-of-type(5) {
        width: 134px;
      }

      .item_:nth-of-type(6) {
        width: 250px;
      }

      .item_ {
        .itemTitle {
          background: #f5f7fa;
          padding: 8px;
          box-sizing: border-box;
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #303133;
          font-weight: 700;
        }

        .itemContent_ {
          height: 76px;
          display: flex;
          align-items: center;

          div {
            font-size: 13px;
            font-family: AlibabaPuHuiTiM;
            color: #008aea;
            border-bottom: 2px #008aea solid;
            line-height: 13px;
            cursor: pointer;
          }

          div:nth-of-type(2) {
            color: #2f744f;
            border-bottom: 2px #2f744f solid;
            margin-left: 16px;
          }
        }

        .itemContent {
          height: 76px;
          padding: 14px 8px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: AlibabaPuHuiTiM;
          color: #606266;
          line-height: 16px;

          img {
            width: 36px;
            margin-right: 8px;
          }
        }
      }
    }
  }
}
</style>
